import { FC } from 'react';

import * as St from './styles';
import { IDarkeningOverlayProps } from './types';

export const DarkeningOverlay: FC<IDarkeningOverlayProps> = (props) => {
  return <St.Overlay {...props} />;
};
